module.exports = __webpack_public_path__ + "static/media/landing1.20fb3125.jpg";